module.exports = __webpack_public_path__ + "img/icons/default-avatar-ebe1838db4ae0479fc7c17d10e504e7f.svg";